module.exports = __webpack_public_path__ + "img/close-3.7e28582a.svg";